/* Tour "periodicity-views" (chapitre back « periodicity_views » — Piloter au
   quotidien). Montre le sélecteur de maille de temps, laisse l'utilisateur
   choisir (jour / semaine / mois) et valider, puis met en avant le tableau qui
   a changé de pas de temps. Insiste sur le point qui déroute souvent les
   clients : les prévisions sont rattachées à la maille choisie.

   La pill « maille » (dash-period) n'est présente que si la feature
   `customizable_dashboard_period_enabled` est activée sur l'entreprise. */

import AppBus from '@/bus/app-bus';
import './types';

window.FygrTour.register('periodicity-views', {
  title: 'Piloter au quotidien',
  page: '/dashboard',
  intro: {
    title: 'Piloter au quotidien',
    body: 'Votre tableau de bord peut se lire au jour, à la semaine ou au mois, selon le niveau de détail dont vous avez besoin. On voit comment changer de vue.',
    startLabel: 'Commencer',
    optoutLabel: 'Désactiver les guides automatiques',
    optoutNote: 'Ils ne s’afficheront plus automatiquement. Vous pourrez les relancer à tout moment depuis « Tutoriels ».',
  },
  onStart: () => {
    // Le moteur peut naviguer vers /dashboard au démarrage → le Dashboard se
    // monte APRÈS. On (ré)émet en rafale pour que la pill « maille » forcée et la
    // vue tableau soient bien appliquées une fois le composant monté.
    let tries = 0;
    const tick = () => {
      // Force l'affichage de la pill « maille » (cas externe au parcours payé).
      AppBus.$emit('tour:period-reveal', true);
      // Le résultat se lit dans le tableau → on s'assure d'être en vue tableau.
      AppBus.$emit('tour:dashboard-table');
      if (++tries < 8) setTimeout(tick, 400);
    };
    tick();
  },
  onExit: () => {
    AppBus.$emit('tour:period-reveal', false);
  },
  steps: [
    {
      target: '[data-tour-step="dash-period"]',
      title: 'Changez de vue',
      body: 'Cliquez ici pour choisir le pas de temps de votre tableau de bord.',
      placement: 'bottom',
      clickToAdvance: true,
      waitFor: '[data-tour-step="period-type"]',
      waitTimeout: 5000,
      // « Suivant » comme le clic sur la pill doivent ouvrir le menu : la zone
      // cliquable est le .c-dropdown interne (l'ancre est sur la racine).
      onNext: () => {
        if (!document.querySelector('[data-tour-step="period-type"]')) {
          (
            document.querySelector(
              '[data-tour-step="dash-period"] .c-dropdown',
            ) as HTMLElement | null
          )?.click();
        }
      },
    },
    {
      target: '[data-tour-step="period-type"]',
      title: 'Jour, semaine ou mois',
      body: 'Ouvrez la liste des pas de temps disponibles.',
      placement: 'right',
      clickToAdvance: true,
      // Menu ouvert : seule la cible reste cliquable → un clic à côté / sur un
      // autre dropdown ne peut plus fermer le menu et casser le tuto.
      strictTarget: true,
      waitFor: '.tour-period-picker .wrapper',
      waitTimeout: 5000,
      // Idem : ouvrir la liste via le .c-dropdown interne du champ maille.
      onNext: () => {
        if (!document.querySelector('.tour-period-picker .wrapper')) {
          (
            document.querySelector(
              '[data-tour-step="period-type"] .c-dropdown',
            ) as HTMLElement | null
          )?.click();
        }
      },
    },
    {
      target: '.tour-period-picker .wrapper',
      title: 'Choisissez votre maille',
      body: 'Sélectionnez par exemple « Jours » pour une vue journalière.',
      placement: 'right',
      clickToAdvance: true,
      strictTarget: true,
      // Pas de nextDelay : « Valider » est juste en dessous → on ré-ancre
      // directement (le délai déclencherait un reset du voile = aller-retour
      // du spotlight vers le coin avant de revenir).
      waitFor: '[data-tour-step="period-validate"]',
      waitTimeout: 5000,
    },
    {
      target: '[data-tour-step="period-validate"]',
      title: 'Appliquez',
      body: 'Cliquez sur « Valider » pour appliquer le nouveau pas de temps.',
      placement: 'right',
      clickToAdvance: true,
      // Menu encore ouvert : on verrouille tout sauf « Valider ».
      strictTarget: true,
      // Laisse le dropdown se fermer + le tableau se recalculer avant le spotlight.
      nextDelay: 900,
    },
    {
      target: '.cash-wrapper',
      title: 'Vos vues ont changé',
      body: 'Visualisez votre suivi de trésorerie à la maille jour ou à la maille semaine. En mode édition, nous vous recommandons de ne pas mélanger des prévisions créées depuis la vue jour avec d’autres créées à la maille mois (ou semaine).',
      placement: 'top',
      lockTarget: true,
      clickToAdvance: false,
      waitTimeout: 5000,
    },
  ],
  celebration: {
    title: 'À vous de jouer',
    body: 'Choisissez la maille adaptée à votre pilotage — et gardez-la pour un prévisionnel cohérent.',
  },
});

export {};
